import {Component, Inject, OnInit} from '@angular/core';
import {Observable} from "rxjs";
import {Centre} from "../../../../interfaces/Centres";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {FullChild} from "../../../../interfaces/FullChild";
import {CentreService} from "../../../../services/centre.service";
import {ChildService} from "../../../../components/child/child.service";
import {CounselingService} from "../../counseling.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MatSelectChange} from "@angular/material/select";
import firebase from "firebase/compat";
import Timestamp = firebase.firestore.Timestamp;
import {LogService} from "../../../../services/log.service";
import {AngularFireDatabase} from "@angular/fire/compat/database";
import {TitleCasePipe} from "@angular/common";
import {GlossaryService} from "../../../../components/glossary/glossary.service";
import {takeUntil} from "rxjs/internal/operators/takeUntil";
import {Subject} from "rxjs/internal/Subject";

@Component({
  selector: 'app-edit-individual-counseling',
  templateUrl: './edit-individual-counseling.component.html',
  styleUrls: ['./edit-individual-counseling.component.scss']
})
export class EditIndividualCounselingComponent implements OnInit {
  centres$: Observable<Centre[]>
  _challengesFaced$: Observable<String[]>;

  form: FormGroup
  children$?: Observable<FullChild[]>
  startTime: any
  endTime: any
  centreSelect = new FormControl('', [Validators.required]);
  childSelect = new FormControl('', [Validators.required]);
  types=["Admission Rapport building counselling","Regular Counselling","Discharge Counselling","Follow-up Counselling", "Others"]
  _interventionsList$: Observable<String[]>
  mGlossaryData:any
  destroyed$ = new Subject()



  constructor(private centreService: CentreService,
              private childService: ChildService,
              private readonly mLogService:LogService,
              private counsellingService: CounselingService,
              private _snackBar: MatSnackBar,
              private titlecasePipe: TitleCasePipe,
              private readonly mGlossary: GlossaryService,

              private readonly mDatabase:AngularFireDatabase,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private dialogRef: MatDialogRef<EditIndividualCounselingComponent>
  ) {
    this._interventionsList$ = this.mDatabase.list<String>('types/Interventions').valueChanges()
    this._challengesFaced$ = this.mDatabase.list<String>('types/Challenges Faced').valueChanges()

    this.centres$ = this.centreService.getAllCentres()
    this.form = new FormGroup({
      centreName: new FormControl(this.data.centreName),
      centreCode: new FormControl(this.data.centreCode, Validators.required),
      childName: new FormControl(this.data.childName),
      childCode: new FormControl(this.data.childCode, Validators.required),
      sessionMode: new FormControl(this.data.sessionMode, Validators.required),
      startTime: new FormControl(this.checkDate((this.data?.startTime)), Validators.required),
      endTime: new FormControl(this.checkDate((this.data?.endTime)), Validators.required),
      participants: new FormControl(this.data.participants, Validators.required),
      date: new FormControl(this.checkDate((this.data?.date)), Validators.required),
      // description: new FormControl(''),
      challengesFaced: new FormControl(this.data.challengesFaced, Validators.required),
      highlight: new FormControl(this.data.highlight, Validators.required),

      interventionUsed: new FormControl(this.data.interventionUsed),
      interventions: new FormControl(this.data.inventions),

      interventionUseful: new FormControl(this.data.interventionUseful),
      interventionRemarks: new FormControl(this.data.interventionRemarks),
      homeProgram: new FormControl(this.data.homeProgram),
      homeProgramEffectiveness: new FormControl(this.data.homeProgramEffectiveness),
      type: new FormControl(this.data.type,Validators.required ),
      remark: new FormControl(this.data.remark, ),
      updatedAt: new FormControl(new Date()),

      // type: new FormControl('',Validators.required),

      // childCode:new FormControl('',Validators.required),
    })
    this.form.get('childName')?.disable()
    this.form.get('centreName')?.disable()
  }

  ngOnInit(): void {
    this.mGlossary.fetchCounsellingGlossary().pipe(takeUntil(this.destroyed$)).subscribe(res=>{

      this.mGlossaryData  =res
    })

    console.log("list: ", this._interventionsList$ )

  }

  fetchChildren($event: MatSelectChange) {
    let centre = $event.value as Centre
    // alert(centre)
    this.children$ = this.childService.getAllotedChildListByCenter(centre.centreCode)
    this.form.get('centreName')?.setValue(centre.centreName)
    this.form.get('centreCode')?.setValue(centre.centreCode)
  }

  onChildSelect($event: MatSelectChange) {
    let child = $event.value as FullChild
    this.form.get('childCode')?.setValue(child.childCode)
    this.form.get('childName')?.setValue(child.firstName + ' ' + child.lastName)
  }

  Submit() {

    if (this.form.valid) {
      this.counsellingService.editIndividualSession(this.form.value,this.data.id).then(() => {
        this._snackBar.open('Session Submitted')._dismissAfter(3000)
        let activity={
          date:new Date().getTime(),
          section: 'Individual Counseling',
          action: 'Update',

          description: `Individual Session for ${this.form.get('childCode')?.value} ${this.form.get('childName')?.value} updated to Counseling by user` ,
          currentIp: localStorage.getItem('currentip')!
        }
        this.mLogService.addLog(activity)
        this.dialogRef.close()
      })
    } else {

      this._snackBar.open('Please enter the form carefully')._dismissAfter(3000)
      console.log(this.findInvalidControls())

    }
  }
  public findInvalidControls() {
    const invalid = [];
    const controls = this.form.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }
  private checkDate(date: any) {
    let d:any=''
    if(date!=null){
      d=(date as Timestamp).toDate()
    }
    else d=null
    return d

}

  Cancel() {
    this.dialogRef.close()
  }
  onBlur(formControl: any) {
  //   if (formControl.value !== null) {
  //     formControl.setValue(this.titlecasePipe.transform(formControl.value.toString().trim().toUpperCase()))
  //   }
  }
}
